import { MarkersTabState } from "./types";
import { createSlice } from '@reduxjs/toolkit'
import { PayloadAction } from "@reduxjs/toolkit";
import { MapTabState } from "../mapTab/types";

const initialState: MarkersTabState = {
  agrochemistry: {
    enabled: false,
    current: ""
  },
  toggles: {},
}

const markersTabSlice = createSlice({
  name: 'markers_tab_slice',
  initialState,
  reducers: {
    resetMarkersTabTabState(state: MarkersTabState, action: PayloadAction) {
      return initialState
    },
    setMarkersTabToggleState(state: MarkersTabState, action: PayloadAction<{ id: string, enabled: boolean }>){
      state.toggles[action.payload.id] = action.payload.enabled
    },
    setMarkersTabCurrentChemistry(state: MarkersTabState, action: PayloadAction<{ provider : string }>){
      state.agrochemistry.current = action.payload.provider
    },
    setMarkersTabLayerAgrochemistryEnabled(state: MarkersTabState, action: PayloadAction<{ enabled: boolean}>){
      state.agrochemistry.enabled = action.payload.enabled
    }
  }
})

export const actions = markersTabSlice.actions
export default markersTabSlice.reducer